import { isEqual } from 'lodash';
import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DEFAULT_SORT_SETTING } from "../app.constants";
import { InspectionImageFilters } from "../_objects/inspection-image-filters";
import { SubjectLocation } from "../_objects/subject-model";
import { InspectionImageFiltersFixture } from "../_fixtures/inspection-image-filters.fixture";

@Injectable({
  providedIn: 'root'
})
export class ImagesFiltersStateService {
  subjectLocation : SubjectLocation = new SubjectLocation();

  private inspectionImagesFiltersSubject = new BehaviorSubject<InspectionImageFilters>({
    subjectLocation: null,
    marks: [],
    sort: DEFAULT_SORT_SETTING.SORT,
    sortOrder: DEFAULT_SORT_SETTING.SORTORDER,
    printScreens: []
  });

  public inspectionImagesFilters$ = this.inspectionImagesFiltersSubject.asObservable();

  get inspectionImageFilters() {
    let inspectionImagefiltersValue :InspectionImageFilters = InspectionImageFiltersFixture();

    this.inspectionImagesFilters$.subscribe(inspectionImagefilters => {inspectionImagefiltersValue = inspectionImagefilters;});
    return inspectionImagefiltersValue;
  }

  set inspectionImageFilters(inspectionImageFilters : InspectionImageFilters) {
    this.updateFilters(inspectionImageFilters);
  }

  get inspectionImagesLocationFilters() : string[] {
    const filterLocations : string[] = [];
    const folderSelected =  this.inspectionImageFilters.subjectLocation;
    if (!folderSelected)
      return filterLocations;

    if (folderSelected.children.length > 0) {
      folderSelected.children.forEach(subLocations => filterLocations.push(subLocations.identifier));
      return filterLocations;
    }
    filterLocations.push(folderSelected.identifier);
    return filterLocations;
  }

  public updateFilters(filters: InspectionImageFilters) {
    if (!isEqual(filters, this.inspectionImagesFiltersSubject.value)) {
      this.inspectionImagesFiltersSubject.next(filters);
    }
  }
}
